import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-definitions',
  templateUrl: './svg-definitions.component.html',
  styleUrls: ['./svg-definitions.component.scss'],
  standalone: false,
})
export class SvgDefinitionsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
